// extracted by mini-css-extract-plugin
export default {"books":"AvailableBooks_books__Mxj+i","books-appear":"AvailableBooks_books-appear__p748B"};